var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3001 7.24267L5.11731 11.3645C5.07339 11.3937 5.02236 11.4105 4.96967 11.413C4.91697 11.4155 4.86457 11.4037 4.81806 11.3788C4.77155 11.3539 4.73266 11.3169 4.70555 11.2716C4.67843 11.2264 4.66409 11.1746 4.66406 11.1218V2.87817C4.66409 2.82541 4.67843 2.77365 4.70555 2.7284C4.73266 2.68314 4.77155 2.64609 4.81806 2.62119C4.86457 2.59629 4.91697 2.58447 4.96967 2.58699C5.02236 2.58951 5.07339 2.60628 5.11731 2.6355L11.3001 6.75734C11.34 6.78397 11.3728 6.82006 11.3954 6.86239C11.4181 6.90472 11.4299 6.95199 11.4299 7C11.4299 7.04802 11.4181 7.09529 11.3954 7.13762C11.3728 7.17995 11.34 7.21603 11.3001 7.24267Z",
    fill: "#3F7CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBlue);
export default __webpack_public_path__ + "static/media/play-blue.1b4aa7d296c1b3b86ea94395ae230d2f.svg";
export { ForwardRef as ReactComponent };